var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('banner',{attrs:{"choose-int":"1506061397380653058"}}),_c('bread',{attrs:{"jup-path":"/culture","jupm-page":"企业文化"}}),_c('div',{staticClass:"custombody"},[_vm._v("文化内容")]),_c('customFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }